var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "-1.6 -1.6 19.20 19.20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1, 0, 0, 1, 0, 0)rotate(0)",
    stroke: "#00bcd4",
    strokeWidth: 0.00016,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.44800000000000006
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1H12V15H16V1Z",
    fill: "#00bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5H10V15H6V5Z",
    fill: "#00bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9H4V15H0V9Z",
    fill: "#00bcd4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.533754cba583de967d9835bb9ca9b098.svg";
export { ForwardRef as ReactComponent };